import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/expressions';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const getExpressions = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.Expressions.crud('', { page, limit, query, sort }))
      .then((response) => {
        dispatch({
          type: Types.GET_EXPRESSIONS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export const getAllExpressions = () => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.Expressions.crud('/getAll'))
      .then((response) => {
        dispatch({
          type: Types.GET_ALL_EXPRESSIONS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export const getExpression = (expressionName) => {
  return dispatch => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.Expressions.crud(`/${expressionName}`))
      .then(response => {
        dispatch({
          type: Types.GET_EXPRESSION,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_EXPRESSION,
          payload: null,
        });
      });
  }
}

export const createExpression = (expression, callback) => {
  return dispatch => {
    axiosInstance.post(serverRoutes.Expressions.crud(), expression)
      .then(response => {
        dispatch({
          type: Types.CREATE_EXPRESSIONS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.CREATE_EXPRESSIONS,
          payload: null,
        });
        callback(false)
      })
  }
}

export const updateExpression = (id, expression, callback) => {
  return (dispatch, getState) => {

    axiosInstance.put(serverRoutes.Expressions.crud(`/${id}`), expression)
      .then(response => {
        dispatch({
          type: Types.UPDATE_EXPRESSIONS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        callback(false);
        const { expressions } = getState();
        console.log(expressions)
        dispatch({
          type: Types.UPDATE_EXPRESSIONS,
          payload: expressions?.expression,
        });
        toast.error(`Erro: ${err.response?.data?.error?.message || err.response?.data?.error || err.response?.data }`, { autoClose: 10000 });
      })
  }
}

export const deleteExpression = (id, callback) => {
  return dispatch => {
    axiosInstance.delete(serverRoutes.Expressions.crud(`/${id}`))
      .then(response => {
        dispatch({
          type: Types.DELETE_EXPRESSIONS,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.DELETE_EXPRESSIONS,
        });
      })
  }
}
